import { EMPTY_IMAGE } from './empty-image';
import { ImageEntry } from '../../state/images';

export const EMPTY_IMAGE_ENTRY: ImageEntry = Object.freeze({
  errors: null,
  image: EMPTY_IMAGE,
  status: null,
  uploadProgress: null,
});
